import type { SxProps, Theme } from '@mui/material';
import { TOUCH_TARGET_PX } from '../config/touch-target';
import { colors } from '../theme/ai-theme';

interface TogglePillGroupOptions {
  /** `true`: the pills share the row width (few fixed choices); `false`: each pill fits its label. */
  fillRow: boolean;
}

/**
 * Rounded, spaced toggle pills of a `ToggleButtonGroup` (warning days of pest control points and of
 * deadlines): 48px tall, white when off, primary when on, faded when disabled.
 */
export function togglePillGroupSx({ fillRow }: TogglePillGroupOptions): SxProps<Theme> {
  return {
    flexWrap: 'wrap',
    gap: 1,
    '& .MuiToggleButton-root': {
      flex: fillRow ? 1 : '0 0 auto',
      border: `1px solid ${colors.border.main} !important`,
      borderRadius: '999px !important',
      px: 2,
      py: 1.25,
      minHeight: TOUCH_TARGET_PX,
      fontWeight: 600,
      fontSize: '0.95rem',
      textTransform: 'none',
      letterSpacing: 0,
      color: colors.text.secondary,
      bgcolor: colors.background.paper,
      '&.Mui-selected': {
        bgcolor: colors.primary.main,
        color: colors.primary.contrastText,
        borderColor: `${colors.primary.main} !important`,
        '&:hover': {
          bgcolor: colors.primary.dark,
        },
      },
      '&.Mui-disabled': {
        color: colors.text.disabled,
        bgcolor: colors.background.elevated,
        borderColor: `${colors.border.light} !important`,
      },
      '&:hover': {
        bgcolor: colors.states.hover,
      },
    },
  };
}
